import { render, staticRenderFns } from "./NewShoppingChart.vue?vue&type=template&id=7b88a2da&scoped=true"
import script from "./NewShoppingChart.vue?vue&type=script&lang=js"
export * from "./NewShoppingChart.vue?vue&type=script&lang=js"
import style0 from "./NewShoppingChart.vue?vue&type=style&index=0&id=7b88a2da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b88a2da",
  null
  
)

export default component.exports